import { LinkSimpleHorizontal } from '@phosphor-icons/react';

import { crownApi } from '@/common/api/crownQueryClient';
import { QueriedListItem } from '@/components/list/QueriedListItem.tsx';
import { CopyToClipboard } from '@/components/ui/CopyToClipboard.tsx';
import { Typography } from '@/components/ui/Typography.tsx';
import { cn } from '@/lib/utils';
import { Components } from '@/openapi';

type APIKeyListItemProps = {
  apiKey: Components.Schemas.APIKeyListItemDto;
};

const revealSecret = async (clientId: string) =>
  (await crownApi.APIKeysAdmin_revealKey({ keyId: clientId })).data.secret;

export const APIKeyListItem = ({ apiKey }: APIKeyListItemProps) => {
  return (
    <QueriedListItem className={'grid grid-cols-2 p-4 py-2'}>
      <div className={'flex flex-col items-start justify-center'}>
        <Typography
          variant={'h4'}
          className={
            '-mb-1 flex items-center justify-start text-lg text-primary'
          }
        >
          <LinkSimpleHorizontal className={cn('w-6 h-6 mr-2')} />
          <span>{apiKey.id}</span>
        </Typography>
        <Typography variant={'muted'}>
          Description:{' '}
          <span className={'italic'}>
            {apiKey.description || 'No description'}
          </span>
        </Typography>
      </div>
      <div className={'flex flex-col items-end justify-center'}>
        <div className={'flex w-full items-center justify-end'}>
          <span className={'mr-2 text-gray-600'}>Client ID: </span>
          <CopyToClipboard className={'max-w-xs'}>{apiKey.id}</CopyToClipboard>
        </div>
        <div className={'flex w-full items-center justify-end'}>
          <span className={'mr-2 text-gray-600'}>Client Secret: </span>
          <CopyToClipboard
            className={'max-w-xs'}
            asyncReveal={() => revealSecret(apiKey.id)}
          >
            Click to reveal secret
          </CopyToClipboard>
        </div>
      </div>
    </QueriedListItem>
  );
};
